// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkNAValues = (arg: any): any => {
  if (arg?.toString()?.toLowerCase() === 'n/a') return '';
  return arg;
};
